var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNormal = function SvgNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.332 79.287c-7.252-8.575-26.577 8.212-33.331 16.213 6.878-4.49 21.15-11.326 26.731-10.804 5.581.523 9.904-1.788 6.6-5.41ZM160.797 76.575c7.484-8.372 27.17 8.743 33.703 16.925-6.753-4.676-21.66-11.707-27.253-11.337-5.593.37-9.851-2.058-6.45-5.588Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.423,
    cy: 135.423,
    r: 87.423,
    stroke: "currentColor",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 151c-4.8 12.8-21 17-28.5 17.5 25.6-.8 33.667-19.667 34.5-29 0-1.5-1.2-1.3-6 11.5ZM71.5 150.5c1 5 4.001 6 3.001 7-5 2-6.5-21.167-6-33.5.5 6.167 2.199 22.5 2.999 26.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5 116.5c-1 4.333-1.4 13 5 13s10.667-10 12-15c-4.5-.333-14.2-.4-17 2Zm6-.5c-.5 1.333-.8 4 2 4s3.833-3.333 4-5l-6 1Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 121c4.333-4.666 19.6-11.3 40-2.5",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.377 150.47c3.618-5.025 5.99-15.112 5.99-23.215 0-8.104-2.372-15.263-5.99-20.288-3.623-5.032-8.25-7.657-12.927-7.657s-9.304 2.625-12.927 7.657c-3.618 5.025-5.99 12.184-5.99 20.288 0 8.103 2.372 15.262 5.99 20.288 3.623 5.031 9.54 9.376 14.217 9.376 4.677 0 8.542-2.149 11.637-6.449Zm-12.927 9.029c12.822 0 23.216-14.436 23.216-32.244S109.272 95.011 96.45 95.011c-12.822 0-23.216 14.436-23.216 32.244s10.394 32.244 23.216 32.244Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.166 120.99c-4.333-4.667-19.6-11.301-40-2.501",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.166 150.989c4.8 12.8 21 17 28.5 17.5-25.6-.8-33.667-19.667-34.5-29 0-1.5 1.2-1.3 6 11.5ZM196.001 150.5c-1 5-4 6-2.834 6.989 4.833 2.511 6.5-21.166 6-33.5-.5 6.167-2.366 22.511-3.166 26.511Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.573 118.169c-1 4.333-1.4 13 5 13s10.666-10 11.999-15c-4.499-.333-14.199-.4-16.999 2Zm5.998-.5c-.5 1.333-.8 4 2 4s3.834-3.333 4.001-5l-6.001 1Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.289 150.46c-3.618-5.026-5.99-15.112-5.99-23.216 0-8.104 2.372-15.263 5.99-20.288 3.623-5.032 8.25-7.657 12.927-7.657s9.304 2.625 12.927 7.657c3.618 5.025 5.989 12.184 5.989 20.288 0 8.104-2.371 15.263-5.989 20.288-3.623 5.032-9.539 9.376-14.217 9.376-4.677 0-8.542-2.149-11.637-6.448Zm12.927 9.028c-12.822 0-23.216-14.436-23.216-32.244S158.394 95 171.216 95c12.822 0 23.216 14.436 23.216 32.244s-10.394 32.244-23.216 32.244ZM132.501 175.5c6.333-.333 21.8 1.3 33 10.5 14 11.5 16.5 22 3 22-4.681 0-8.459-.661-12.087-1.296-6.836-1.195-13.134-2.297-23.913 1.296-16.5 5.5-30 10-32.5-1s-1.5-29 32.5-31.5ZM130 199c7.499-2.5 20 .5 23.5 3 1.358.971.08.811-2.519.486-4.097-.512-11.475-1.433-16.981 1.014-9 4-14.5 6-13.5 3s6.5-6.5 9.5-7.5Z",
    fill: "currentColor"
  })));
};
export default SvgNormal;